// require("./bootstrap")
window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.Vue = require('vue').default;

// Router for switching page
import VueRouter from 'vue-router'
Vue.use(VueRouter)

// Progressbar or loadingbar on top of page
import VueProgressBar from 'vue-progressbar'
Vue.use(VueProgressBar, { color: '#fff', failedColor: 'red', transition: { speed: '0.2s', opacity: '0.6s', termination: 300 }, thickness: '1px', })

// Axios for get data
import axios from 'axios'
axios.defaults.baseURL = '/api/'
axios.get('/v1/visitor') .then(response => { console.log(response.data.value) }) .catch(error => { console.log(error) })

/** GENERAL COMPONENTS **/
Vue.component("template-navbar", require("./template/Navbar.vue").default)
Vue.component("template-footer", require("./template/Footer.vue").default)

/** ALL ROUTE **/
const router = new VueRouter({
    mode: 'history',
    routes: [
        // { path: '/login', redirect: '/' },
        // Menu Utama
        { name: 'Home', path: '/', component: require('./pages/Home.vue').default },
        { name: 'Produk', path: '/produk', component: require('./pages/Produk.vue').default },
        { name: 'Harga', path: '/harga', component: require('./pages/Harga.vue').default },
        { name: 'Panduan', path: '/panduan', component: require('./pages/Panduan.vue').default },
        { name: 'PanduanHapusAkun', path: '/panduan/hapus-akun', component: require('./pages/DeleteAccount.vue').default },
        { name: 'Blog', path: '/blog', component: require('./pages/Blog.vue').default },
        { name: 'BlogDetail', path: '/blog/:slug', component: require('./pages/BlogDetail.vue').default },
        { name: 'SyaratKetentuan', path: '/terms_condition', component: require('./pages/SyaratKetentuan.vue').default },
        { name: 'Privasi', path: '/privacy', component: require('./pages/Privasi.vue').default },
        { name: 'RiotBali', path: '/riotbali', component: require('./pages/RiotBali.vue').default },
        // Informasi
        { path: '*', component: require('./pages/NotFound.vue').default }
    ],
    scrollBehavior(to, from, savedPosition) {
        return { x: 0, y: 0 }
    },
    linkActiveClass: "active"
})

/** INITIALIZE VUE **/
const app = new Vue({
    el: "#awan-app",
    router,
})
